import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { BagFill } from 'react-bootstrap-icons';
import '../styles/tables.css';
import CrearCompra from './componentes/crearCompraModal';
import CardCompra from './componentes/cardCompras';
import TablaCompra from './componentes/tablaCompras';

function AdminCompras() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='mx-2 mt-3'>
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
        <p className='mb-2 mb-md-0 text-center'>
          Administra las compras que realizas para medir los gastos de tu negocio. 
        </p>
        <div className='d-flex mt-2 mt-md-0'>
          <Button variant='danger' onClick={handleShow}>
            <BagFill /> Nueva Compra
          </Button>
        </div>
      </div>
      {/* Modal crear nueva compra */}
      <CrearCompra show={show} handleClose={handleClose} />
      {/* Card de Stats */}
      <div className='mt-4'>
        <CardCompra />
      </div>
      {/* Tabla de compras */}
      <div className='my-2'>
        <TablaCompra />
      </div>
    </div>
  );
}

export default AdminCompras;